module.exports = __webpack_public_path__ + "static/media/Algorithmic toolbox.38a56514.png";